import './BookDownload.css';
import PreviewEnd from '../../../Assets/Images/preview-end.png'
import * as React from "react";
import {Alert, Divider, LinearProgress, Paper} from "@mui/material";
import TitleWithText from "../../../Components/TitleWithText/TitleWithText";
import {isAdmin} from "../../../Functions/Authentication";
import BookEditButton from "../../../Components/BookGallery/BookEditButton";
import {withRouter} from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import BookmarkButton from "../../../Components/BookmarkButton/BookmarkButton";
import {addThis, getSharingUrl} from "../../../Functions/AddThis";
import BookDetailsTable from "./Component/BookDetailsTable";
import BookReadOnlineButton from "./Component/BookReadOnlineButton";
import BookDownloadButton from "./Component/BookDownloadButton";
import Comments from "../../../Components/Comments/Comments";
import DownloadLimit from "../../../Components/DownloadLimit/DownloadLimit";
import {formatBookName} from "../../../Functions/Formatter";
import {isAdsEnabled, showAds} from "../../../Functions/Ads";

class BookDownload extends React.Component {
  state = {
    data: null
  }

  componentDidMount() {
    this.updateBreadcrumbs();
    this.loadBook();
  }

  loadBook() {
    fetch('/api/books/' + this.props.match.params.id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(response.status.toString())
      }
    })
    .then(data => {
      this.setState({data: data});
      this.updateBreadcrumbs(formatBookName(data.name));
    })
    .catch(error => {
      this.setState({
        data: null,
        errorMessage: error?.message === "404"
            ? "The book you are looking for could not be found."
            : "An unknown error has occurred loading this page, please try again later."
      });
      this.updateBreadcrumbs(error?.message === "404" ? "Not Found" : "Unknown Error");
    });
  }

  updateBreadcrumbs(pageName) {
    const breadcrumbs = pageName ? [{label: pageName, link: "/books/" + this.props.match.params.id}] : [];
    this.props.setBreadcrumbs([{label: "Books", link: "/books/browse/all"}, ...breadcrumbs]);
  }

  render() {
    return (
        <div className={"book-download-page"}>
          {
            (this.state.data == null && this.state.errorMessage == null) &&
            <LinearProgress/>
          }
          {
            (this.state.data == null && this.state.errorMessage != null) &&
              <React.Fragment>
                <Alert severity="error">{this.state.errorMessage}</Alert>
              </React.Fragment>
          }
          {
            (this.state.data != null && this.state.errorMessage == null) &&
            <div>
              <TitleWithText align="left" title="Book Details" endIcon={isAdmin() && <BookEditButton className="book-download-edit" bookId={this.state.data.id} onDataChanged={this.loadBook.bind(this)}/>}>
                <BookDetailsTable data={this.state.data}/>
              </TitleWithText>
              <TitleWithText align="left" title="Read Later" style={{marginTop: "2em"}} className={"books-download-read-later"}>
                <BookmarkButton variant={"button"} itemType="books" itemId={this.state.data.id} lazyLoad={true}/>
              </TitleWithText>
              <TitleWithText align="left" title="Share" style={{marginTop: "2em"}}>
                <div className="addthis_inline_share_toolbox" data-url={getSharingUrl()}/>
              </TitleWithText>
              {addThis()}
              {
                isAdsEnabled() &&
                <TitleWithText align="left" title="Advertisement" style={{marginTop: "2em"}}>
                  {showAds("7214190780")}
                </TitleWithText>
              }
              <TitleWithText align="left" title="Preview" style={{marginTop: "2em"}}>
                <Carousel autoPlay={false} animation={"slide"} navButtonsAlwaysVisible={true} swipe={false}>
                  {
                    [...this.state.data.screenshots, PreviewEnd].map((url, i) => {
                      return (
                          <Paper key={i} className={"book-screenshot-paper"}>
                            <div className="book-screenshot-wrapper">
                              <div className="book-screenshot" style={{backgroundImage: "url(" + url + ")"}}/>
                            </div>
                          </Paper>
                      );
                    })
                  }
                </Carousel>
              </TitleWithText>
              <TitleWithText align="left" title="Download" style={{marginTop: "2em"}}>
                <div className="book-download-buttons">
                  <BookReadOnlineButton bookId={this.state.data.id} bookName={this.state.data.name} fileName={this.state.data.fileName} />
                  <Divider orientation="vertical" flexItem className="book-download-separator"/>
                  <BookDownloadButton className="book-download-button" bookId={this.state.data.id} fileName={this.state.data.fileName} size={this.state.data.size}/>
                </div>
                <DownloadLimit style={{marginTop: "2em"}} action="read online or download" mediaType="books"/>
              </TitleWithText>
              {
                isAdsEnabled() &&
                <TitleWithText align="left" title="Advertisement" style={{marginTop: "2em"}}>
                  {showAds("8479687917")}
                </TitleWithText>
              }
              <TitleWithText align="left" title="Comments" style={{marginTop: "2em"}} className={"books-comments-wrapper"}>
                <Comments className={"books-comments"} id={"books-" + this.state.data.id} title={"Book - " + formatBookName(this.state.data.name)}/>
              </TitleWithText>
            </div>
          }
        </div>
    );
  }
}

export default withRouter(BookDownload);
